import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, EventEmitter, Inject, Input, HostBinding, Output, ContentChild, ContentChildren, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/animations';
import { style, animate } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
const _c0 = ["*"];
const _c1 = [[["mgl-timeline-entry-side"]], [["mgl-timeline-entry-dot"]], [["mgl-timeline-entry-header"]], [["mgl-timeline-entry-content"]]];
const _c2 = ["mgl-timeline-entry-side", "mgl-timeline-entry-dot", "mgl-timeline-entry-header", "mgl-timeline-entry-content"];
let MglTimelineEntryHeaderComponent = /*#__PURE__*/(() => {
  class MglTimelineEntryHeaderComponent {}
  MglTimelineEntryHeaderComponent.ɵfac = function MglTimelineEntryHeaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MglTimelineEntryHeaderComponent)();
  };
  MglTimelineEntryHeaderComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MglTimelineEntryHeaderComponent,
    selectors: [["mgl-timeline-entry-header"]],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MglTimelineEntryHeaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["mgl-timeline-entry-header{position:relative;display:block;overflow:hidden;padding:15px;text-align:center}\n"],
    encapsulation: 2
  });
  return MglTimelineEntryHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MglTimelineEntryDotComponent = /*#__PURE__*/(() => {
  class MglTimelineEntryDotComponent {
    constructor(animationBuilder, elementRef, renderer, changeDetectorRef, document) {
      this.animationBuilder = animationBuilder;
      this.elementRef = elementRef;
      this.renderer = renderer;
      this.changeDetectorRef = changeDetectorRef;
      this.document = document;
      this._expanded = false;
      this._alternate = false;
      this._mobile = false;
      this._size = 50;
      this.animationDone = new EventEmitter();
      this.expandAnimationTiming = '200ms ease';
      this.collapseAnimationTiming = '100ms ease';
      this.clazz = 'primary';
    }
    set size(size) {
      this._size = size;
      this.setStyle();
    }
    get size() {
      return this._size;
    }
    set alternate(alternate) {
      this._alternate = alternate;
      this.setStyle();
    }
    get alternate() {
      return this._alternate;
    }
    set mobile(mobile) {
      this._mobile = mobile;
      this.setStyle();
    }
    get mobile() {
      return this._mobile;
    }
    set expanded(expanded) {
      const animate = this._expanded !== expanded;
      this._expanded = expanded;
      animate ? this.animate() : this.setStyle();
    }
    get expanded() {
      return this._expanded;
    }
    ngAfterViewInit() {
      this.initialStyle = this.document.defaultView.getComputedStyle(this.elementRef.nativeElement);
      this.setStyle();
      this.changeDetectorRef.detectChanges();
    }
    getCollapsedStyle() {
      return {
        top: '50%',
        left: this.alternate || this.mobile ? '-5px' : 'calc(100% + 5px)',
        width: this.size + 'px',
        height: this.size + 'px',
        opacity: 1,
        transform: 'translateY(-50%) translateX(-50%)',
        boxShadow: this.initialStyle && this.initialStyle.boxShadow,
        borderRadius: '100px'
      };
    }
    getTransitionStyle() {
      return {
        ...this.getCollapsedStyle(),
        left: '50%',
        opacity: 0.5,
        boxShadow: 'none'
      };
    }
    getExpandedStyle() {
      return {
        ...this.getTransitionStyle(),
        left: '0',
        transform: 'translateX(0) translateY(-50%)',
        width: '100%',
        height: '100%',
        opacity: 1,
        borderRadius: 0
      };
    }
    animate() {
      this.destroyAnimation();
      if (this.expanded) {
        this.animation = this.animationBuilder.build([style(this.getCollapsedStyle()), animate(this.expandAnimationTiming, style(this.getTransitionStyle())), animate(this.expandAnimationTiming, style(this.getExpandedStyle()))]).create(this.elementRef.nativeElement);
        this.animation.onDone(() => this.animationDone.emit({
          toState: 'expanded'
        }));
        this.animation.play();
      } else {
        this.animationBuilder;
        this.animation = this.animationBuilder.build([style(this.getExpandedStyle()), animate(this.collapseAnimationTiming, style(this.getTransitionStyle())), animate(this.collapseAnimationTiming, style(this.getCollapsedStyle()))]).create(this.elementRef.nativeElement);
        this.animation.onDone(() => this.animationDone.emit({
          toState: 'collapsed'
        }));
        this.animation.play();
      }
    }
    setStyle() {
      this.destroyAnimation();
      const baseStyle = this.expanded ? this.getExpandedStyle() : this.getCollapsedStyle();
      Object.keys(baseStyle).forEach(property => {
        this.renderer.setStyle(this.elementRef.nativeElement, property, baseStyle[property]);
      });
    }
    destroyAnimation() {
      if (this.animation) {
        this.animation.destroy();
        delete this.animation;
      }
    }
  }
  MglTimelineEntryDotComponent.ɵfac = function MglTimelineEntryDotComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MglTimelineEntryDotComponent)(i0.ɵɵdirectiveInject(i1.AnimationBuilder), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DOCUMENT));
  };
  MglTimelineEntryDotComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MglTimelineEntryDotComponent,
    selectors: [["mgl-timeline-entry-dot"]],
    hostVars: 2,
    hostBindings: function MglTimelineEntryDotComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.clazz);
      }
    },
    inputs: {
      expandAnimationTiming: "expandAnimationTiming",
      collapseAnimationTiming: "collapseAnimationTiming",
      clazz: [0, "class", "clazz"],
      size: "size"
    },
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MglTimelineEntryDotComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["mgl-timeline-entry-dot{display:block;position:absolute}\n"],
    encapsulation: 2
  });
  return MglTimelineEntryDotComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MglTimelineEntryContentComponent = /*#__PURE__*/(() => {
  class MglTimelineEntryContentComponent {
    constructor(elementRef, animationBuilder, renderer) {
      this.elementRef = elementRef;
      this.animationBuilder = animationBuilder;
      this.renderer = renderer;
      this.expandAnimationTiming = '200ms ease';
      this.collapseAnimationTiming = '100ms ease';
      this.animationDone = new EventEmitter();
      this._expanded = false;
    }
    set expanded(expanded) {
      this.contentHeight = this.elementRef.nativeElement.scrollHeight;
      const animate = this._expanded !== expanded;
      this._expanded = expanded;
      animate ? this.animate() : this.setStyle;
    }
    get expanded() {
      return this._expanded;
    }
    ngAfterViewInit() {
      this.contentHeight = this.elementRef.nativeElement.scrollHeight;
      this.setStyle();
    }
    getCollapsedStyle() {
      return {
        height: '0px'
      };
    }
    getExpandedStyle() {
      return {
        height: this.contentHeight + 'px'
      };
    }
    animate() {
      if (this.expanded) {
        const animation = this.animationBuilder.build([style(this.getCollapsedStyle()), animate(this.expandAnimationTiming, style(this.getExpandedStyle()))]).create(this.elementRef.nativeElement);
        animation.onDone(() => this.animationDone.emit({
          toState: 'expanded'
        }));
        animation.play();
      } else {
        this.animationBuilder;
        const animation = this.animationBuilder.build([style(this.getExpandedStyle()), animate(this.collapseAnimationTiming, style(this.getCollapsedStyle()))]).create(this.elementRef.nativeElement);
        animation.onDone(() => this.animationDone.emit({
          toState: 'collapsed'
        }));
        animation.play();
      }
    }
    setStyle() {
      const baseStyle = this.expanded ? this.getExpandedStyle() : this.getCollapsedStyle();
      Object.keys(baseStyle).forEach(property => {
        this.renderer.setStyle(this.elementRef.nativeElement, property, baseStyle[property]);
      });
    }
  }
  MglTimelineEntryContentComponent.ɵfac = function MglTimelineEntryContentComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MglTimelineEntryContentComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AnimationBuilder), i0.ɵɵdirectiveInject(i0.Renderer2));
  };
  MglTimelineEntryContentComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MglTimelineEntryContentComponent,
    selectors: [["mgl-timeline-entry-content"]],
    inputs: {
      expandAnimationTiming: "expandAnimationTiming",
      collapseAnimationTiming: "collapseAnimationTiming"
    },
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    template: function MglTimelineEntryContentComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵprojection(1);
        i0.ɵɵelementEnd();
      }
    },
    styles: ["mgl-timeline-entry-content{position:relative;display:block;overflow:hidden}mgl-timeline-entry-content>div{padding:10px}\n"],
    encapsulation: 2
  });
  return MglTimelineEntryContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MglTimelineEntrySideComponent = /*#__PURE__*/(() => {
  class MglTimelineEntrySideComponent {
    constructor(elementRef) {
      this.elementRef = elementRef;
    }
    set alternate(value) {
      this.elementRef.nativeElement.classList.toggle('alternate', value);
    }
    set mobile(value) {
      this.elementRef.nativeElement.classList.toggle('mobile', value);
    }
  }
  MglTimelineEntrySideComponent.ɵfac = function MglTimelineEntrySideComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MglTimelineEntrySideComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  MglTimelineEntrySideComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MglTimelineEntrySideComponent,
    selectors: [["mgl-timeline-entry-side"]],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MglTimelineEntrySideComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    styles: ["mgl-timeline-entry-side{position:absolute;top:0;left:100%;width:100%;text-align:center}mgl-timeline-entry-side.alternate{left:-100%}mgl-timeline-entry-side.mobile{display:none}\n"],
    encapsulation: 2
  });
  return MglTimelineEntrySideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MglTimelineEntryComponent = /*#__PURE__*/(() => {
  class MglTimelineEntryComponent {
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.subscriptions = [];
      this.focusOnOpen = false;
      this._mobile = false;
      this.changed = new EventEmitter();
      this.animationDone = new EventEmitter();
    }
    set expanded(expanded) {
      if (this.dot && expanded) {
        this.dot.expanded = expanded;
      } else {
        this.content.expanded = expanded;
      }
      this.changed.emit(expanded);
    }
    get expanded() {
      return this.dot ? this.dot.expanded && this.content.expanded : this.content.expanded;
    }
    set mobile(value) {
      this.elementRef.nativeElement.classList.toggle('mobile', value);
      if (this.dot) {
        this.dot.mobile = value;
      }
      if (this.side) {
        this.side.mobile = value;
      }
    }
    ngAfterViewInit() {
      if (this.dot) {
        this.subscriptions.push(this.dot.animationDone.subscribe(event => {
          if (event.toState === 'expanded') {
            this.content.expanded = true;
          } else {
            this.animationDone.emit(event);
          }
        }));
      }
      if (this.content) {
        this.subscriptions.push(this.content.animationDone.subscribe(event => {
          if (this.dot && event.toState === 'collapsed') {
            this.dot.expanded = false;
          } else {
            if (this.focusOnOpen) {
              this.elementRef.nativeElement.scrollIntoView({
                behavior: 'smooth'
              });
            }
            this.animationDone.emit(event);
          }
        }));
      }
    }
    set alternate(value) {
      this.elementRef.nativeElement.classList.toggle('alternate', value);
      if (this.dot) {
        this.dot.alternate = value;
      }
      if (this.side) {
        this.side.alternate = value;
      }
    }
    ngOnDestroy() {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    collapse() {
      this.expanded = false;
    }
    expand() {
      this.expanded = true;
    }
    toggle(event) {
      const headerFound = this.containsInPath(event, 'mgl-timeline-entry-header');
      const dotFound = this.containsInPath(event, 'mgl-timeline-entry-dot');
      if (headerFound || dotFound) {
        this.expanded = !this.expanded;
      }
    }
    containsInPath(mouseEvent, name) {
      let currentElem = mouseEvent.target;
      while (currentElem) {
        if (currentElem.localName === name) {
          return true;
        }
        currentElem = currentElem.parentElement;
      }
      return false;
    }
  }
  MglTimelineEntryComponent.ɵfac = function MglTimelineEntryComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MglTimelineEntryComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  MglTimelineEntryComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MglTimelineEntryComponent,
    selectors: [["mgl-timeline-entry"]],
    contentQueries: function MglTimelineEntryComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, MglTimelineEntryContentComponent, 5);
        i0.ɵɵcontentQuery(dirIndex, MglTimelineEntryHeaderComponent, 5);
        i0.ɵɵcontentQuery(dirIndex, MglTimelineEntryDotComponent, 5);
        i0.ɵɵcontentQuery(dirIndex, MglTimelineEntrySideComponent, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.header = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dot = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.side = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MglTimelineEntryComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("expanded", ctx.expanded);
      }
    },
    outputs: {
      changed: "expand",
      animationDone: "animationDone"
    },
    ngContentSelectors: _c2,
    decls: 6,
    vars: 0,
    consts: [[1, "mgl-timeline-entry-card"], [1, "mgl-timeline-entry-card-header", 3, "click"]],
    template: function MglTimelineEntryComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c1);
        i0.ɵɵprojection(0);
        i0.ɵɵelementStart(1, "div", 0)(2, "div", 1);
        i0.ɵɵlistener("click", function MglTimelineEntryComponent_Template_div_click_2_listener($event) {
          return ctx.toggle($event);
        });
        i0.ɵɵprojection(3, 1);
        i0.ɵɵprojection(4, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(5, 3);
        i0.ɵɵelementEnd();
      }
    },
    styles: ["mgl-timeline-entry{display:block;position:relative;margin-bottom:50px;width:calc(50% - 5px)}mgl-timeline-entry.alternate{margin-left:calc(50% + 5px)}mgl-timeline-entry.mobile{width:calc(100% - 30px);margin-left:30px}mgl-timeline-entry .mgl-timeline-entry-card{background-color:#f0f0f0}mgl-timeline-entry .mgl-timeline-entry-card .mgl-timeline-entry-card-header{position:relative;background-color:#e6e6e6}\n"],
    encapsulation: 2
  });
  return MglTimelineEntryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MglTimelineComponent = /*#__PURE__*/(() => {
  class MglTimelineComponent {
    constructor(elementRef, changeDetectorRef) {
      this.elementRef = elementRef;
      this.changeDetectorRef = changeDetectorRef;
      this.toggle = true;
      this.mobileWidthThreshold = 640;
      this.alternate = true;
      this.side = 'left';
      this._focusOnOpen = false;
      this.subscriptions = [];
    }
    set mobile(value) {
      this.content && this.content.forEach(entry => entry.mobile = value);
      this.elementRef.nativeElement.classList.toggle('mobile', value);
    }
    get mobile() {
      return this.elementRef.nativeElement.classList.contains('mobile');
    }
    set focusOnOpen(focusOnOpen) {
      this.content && this.content.forEach(entry => entry.focusOnOpen = focusOnOpen);
      this._focusOnOpen = focusOnOpen;
    }
    get focusOnOpen() {
      return this._focusOnOpen;
    }
    ngOnChanges(simpleChanges) {
      this.updateContent();
    }
    ngOnDestroy() {
      this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
    ngAfterViewInit() {
      this.mobile = this.elementRef.nativeElement.clientWidth < this.mobileWidthThreshold;
      setTimeout(() => this.updateContent());
      this.content.changes.subscribe(changes => {
        this.updateContent();
      });
    }
    updateContent() {
      this.ngOnDestroy();
      if (this.content) {
        this.content.forEach((entry, index) => {
          if (this.toggle) {
            this.subscriptions.push(entry.changed.subscribe(state => {
              if (state === true) {
                this.content.filter(e => e !== entry).forEach(e => e.collapse());
              }
            }));
          }
          entry.alternate = this.alternate ? index % 2 !== 0 : this.side === 'right';
          entry.mobile = this.mobile;
          entry.focusOnOpen = this.focusOnOpen;
        });
      }
    }
    onResize(ev) {
      this.mobile = this.elementRef.nativeElement.clientWidth < this.mobileWidthThreshold;
    }
  }
  MglTimelineComponent.ɵfac = function MglTimelineComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MglTimelineComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
  };
  MglTimelineComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MglTimelineComponent,
    selectors: [["mgl-timeline"]],
    contentQueries: function MglTimelineComponent_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, MglTimelineEntryComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t);
      }
    },
    hostBindings: function MglTimelineComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("resize", function MglTimelineComponent_resize_HostBindingHandler($event) {
          return ctx.onResize($event);
        }, false, i0.ɵɵresolveWindow);
      }
    },
    inputs: {
      toggle: "toggle",
      mobileWidthThreshold: "mobileWidthThreshold",
      alternate: "alternate",
      side: "side",
      focusOnOpen: "focusOnOpen"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c0,
    decls: 2,
    vars: 0,
    consts: [[1, "mgl-timeline-line"]],
    template: function MglTimelineComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelement(0, "div", 0);
        i0.ɵɵprojection(1);
      }
    },
    styles: ["mgl-timeline{position:relative;display:block;padding:50px 0}mgl-timeline .mgl-timeline-line{position:absolute;top:0;height:100%;background-color:#a0a0a0;left:50%;width:10px;transform:translate(-50%)}mgl-timeline.mobile .mgl-timeline-line{left:20px;transform:none}\n"],
    encapsulation: 2
  });
  return MglTimelineComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MglTimelineModule = /*#__PURE__*/(() => {
  class MglTimelineModule {}
  MglTimelineModule.ɵfac = function MglTimelineModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MglTimelineModule)();
  };
  MglTimelineModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MglTimelineModule
  });
  MglTimelineModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return MglTimelineModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MglTimelineComponent, MglTimelineEntryComponent, MglTimelineEntryContentComponent, MglTimelineEntryDotComponent, MglTimelineEntryHeaderComponent, MglTimelineEntrySideComponent, MglTimelineModule };

